export function hasPermission(permissions: string[], permission: string) {
  return permissions.includes(permission);
}

export function hasMissionPermission(mission, action) {
  return mission && mission.actions && mission.actions.includes(action);
}
